import { t } from '@lingui/macro';

export const standardError = (): string => t`Oops! Something went wrong.`;
